import axios from "./axios";

const BASE_URL = process.env.REACT_APP_API_URL_SERVER;

export default {
  dynamic: {
    deletePencipta(creator_id) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`${BASE_URL}/api/user/creator/${creator_id}`)
          .then((response) => {
            const { data } = response.data;
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    deleteAdmin(creator_id) {
        return new Promise((resolve, reject) => {
            axios
            .delete(`${BASE_URL}/api/user/admin/${creator_id}`)
            .then((response) => {
                const { data } = response.data;
                resolve(data);
            })
            .catch((err) => {
                reject(err);
            });
        });
        },
      deleteSong(song_id) {
        return new Promise((resolve, reject) => {
          axios
            .delete(`${BASE_URL}/api/song/${song_id}`)
            .then((response) => {
              const { data } = response.data;
              resolve(data);
            })
            .catch((err) => {
              reject(err);
            });
        });
      },
  },
};
